import { Image } from "@huub-web/ui";
import type { FC } from "react";

export type AnalysisObservationMainImageProps = {
  src?: string;
  alt: string;
  loading?: boolean;
  onClick?: () => void;
};

export const AnalysisObservationMainImage: FC<
  AnalysisObservationMainImageProps
> = ({ src, alt, loading, onClick }) => (
  <Image
    borderRadius
    src={loading ? undefined : src}
    alt={alt}
    onClick={onClick}
    outline
  />
);
